<template>
  <div class="Top-container el-headerClass">
    <!--收缩按钮-->
    <div style="flex:1;">
      <span :class="fff_top_foldData" @click="fff_top_foldClick" style="font-size: 18px;cursor: pointer"></span>
      <!--位置标记面包屑-->
      <div style="display: inline-block;margin-left: 10px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="'/home'">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ currentPathName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <!--    <span style="margin-right: 30px;font-size: 14px;"> 可用次数->{{ fff_top_user.balance }}</span>-->
    <div style="display: inline-block;margin-right: 30px;">
      <el-tooltip placement="top" effect="light">
        <div slot="content">
          <img src="../../css_assets/contact.png" alt="客服微信" style="max-width: 300px;"/>
        </div>
        <el-button type="text" size="medium">客服微信</el-button>
      </el-tooltip>
    </div>
    <!--个人中心-->
    <el-dropdown style="width:160px;cursor: pointer;text-align: right">
      <!--左上角头像展示-->
      <div style="display: inline-block;">
        <img :src="fff_top_user.avatar"
             style="width: 30px;border-radius: 10%;position: relative;top:5px;right: 5px;">
        <span>{{ fff_top_user.nick }}</span><i class="el-icon-arrow-down" style="margin-left: 5px"></i>
      </div>
      <el-dropdown-menu slot="dropdown" style="width: 150px;text-align: center;">

        <el-dropdown-item style="font-size: 14px;padding: 5px 0" @click.native="person">
          <span style="text-decoration: none;color: gray;">个人信息</span>
          <!--<js_router-link to="/person" style="text-decoration: none;color: gray">个人信息</js_router-link>-->
        </el-dropdown-item>

        <!--        <el-dropdown-item style="font-size: 14px;padding: 5px 0" @click.native="password">
                  <span style="text-decoration: none;color: gray;">修改密码</span>
                  &lt;!&ndash;<js_router-link to="/password" style="text-decoration: none;color: gray">修改密码</js_router-link>&ndash;&gt;
                </el-dropdown-item>-->

        <el-dropdown-item style="font-size: 14px;padding: 5px 0;" @click.native="logoutClick">
          <span style="text-decoration: none;color: gray;">退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>

    </el-dropdown>
  </div>
</template>

<script>
import myVuex from "@/js_store/myVuex";

export default {
  name: "Top",
  props: ['fff_top_foldData', 'fff_top_foldClick', 'fff_top_pathName', 'fff_top_user'],/*说明props还可以接受函数，我日尼玛哦*/
  data() {
    return {}
  },
  methods: {
    person() {
      this.$router.push('/person')
    },
    password() {
      this.$router.push('/password')
    },
    logoutClick() {
      myVuex.commit("userLogout")
      this.$message.success("退出成功")
    }
  },
  computed: {
    currentPathName: {
      get() {
        return myVuex.state.currentPathName
        //return this.$js_store.state.currentPathName
      },
      set() { // 不写会报错的
      }
    }
  },
}
</script>

<style scoped>
/*右侧头部*/
.el-headerClass {
  font-size: 12px;
  border-bottom: 1px solid #cccccc;
  line-height: 60px;
  display: flex;
}

/*收缩菜单*/
.foldClass {
  cursor: pointer;
}
</style>
